import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FiltersService } from "../../../services/filters.service";

@Component({
  selector: "app-pager",
  templateUrl: "./pager.component.html",
})
export class PagerComponent implements OnInit, OnChanges {
  @Input() count: number = 0;
  @Input() pageSize: number = 10;
  @Input() pageNumber: number;
  @Input() availablePageSizes: number[] | null;
  @Output() emitChangePage = new EventEmitter<number>();
  @Output() emitChangePageSize = new EventEmitter<number>();

  manualPageChange = false;
  pageReady: boolean = false;
  constructor(private filtersService: FiltersService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.pageReady = true;
    }, 1000);
  }

  onPageChange(page: number): void {
    if (this.manualPageChange) {
      this.changePage(page);
      this.manualPageChange = false;
    }
  }

  changePage(event: number) {
    this.filtersService.updateMultipleQueryFilters({ page: this.pageNumber});
    this.emitChangePage.emit(event);
  }

  get changePageSize() {
    return this.pageSize;
  }

  set changePageSize(pageSize: number) {
    this.pageSize = pageSize;
    this.pageNumber = 1;
    this.emitChangePageSize.emit(pageSize);
  }

  detectChangePageSize(pageSize: number) {
    this.filtersService.updateMultipleQueryFilters({ page: 1, size: pageSize });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pageSize'] && !changes['pageSize'].firstChange) {
      const newSize = changes['pageSize'].currentValue;
      this.pageNumber = 1;
      this.detectChangePageSize(newSize);
    }
  }
}
